import { Action } from '../actions';

const defaultState = {
  loading: true,
  saved: false,
  error: false,
  errorMessage: null,
};

const checkError = (action) => {
  if (!action.payload) {
    return {};
  }

  const { status, body } = action.payload;

  let details = body;
  let error = false;
  let errorMessage = null;
  if (status >= 400) {
    details = null;
    error = true;
    errorMessage = body.message || body.error;
  }

  return {
    details,
    error,
    errorMessage,
  };
};

export default function poi(poiState = defaultState, action) {
  switch (action.type) {
    case Action.Poi.DetailsCompleted:
      return {
        ...poiState,
        ...checkError(action),
        loading: false,
      };
    case Action.Poi.PoiBrandRemoveCompleted:
    case Action.Poi.PoiBrandCompleted: {
      return {
        ...poiState,
        ...checkError(action),
        loading: false,
        saved: true,
      };
    }
    case Action.Poi.PoiBrandPending:
    case Action.Poi.PoiBrandRemovePending:
      return {
        ...poiState,
        loading: true,
      };
    case Action.Poi.PoiPayStatusPending:
      return {
        ...poiState,
        loading: true,
        saved: false,
      };
    case Action.Poi.PoiPayStatusCompleted:
      return {
        ...poiState,
        ...checkError(action),
        saved: true,
        loading: false,
      };
    default:
      break;
  }
  return poiState;
}
